import type { SupabaseClientOptions } from '@supabase/supabase-js';
import {
  PaymentNotConfiguredError,
  type CheckoutSession,
  type CheckoutSessionInput,
  type IPaymentService,
  type PaymentVerification,
} from '../../interfaces/src';

/**
 * Flouci payments — thin proxy to the `flouci-checkout` / `flouci-verify`
 * edge functions, which hold the Flouci tokens server-side and compute the
 * price from the plan (the client never sends an amount).
 *
 * Flouci has NO recurring billing: subscribing and renewing are the same
 * one-shot flow. Settlement (verify → period extension) is server-side and
 * idempotent; this class only starts checkouts and asks for settlement.
 */
export class FlouciPaymentService implements IPaymentService {
  readonly provider = 'flouci' as const;

  constructor(_url: string, _anonKey: string, _options?: SupabaseClientOptions<'public'>) {}

  async createCheckoutSession(_input: CheckoutSessionInput): Promise<CheckoutSession> {
    throw new PaymentNotConfiguredError('online_payments_on_hold');
  }

  async verifyPendingPayments(_paymentId?: string): Promise<PaymentVerification> {
    throw new PaymentNotConfiguredError('online_payments_on_hold');
  }
}
